import { Box, BoxProps, ColorOptions, Spacer, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { useState } from 'react'

export const EditPackage = ({ data, update, close }: any) => {
  const [groupName, setGroupname] = useState<string>(data?.group)
  const [packageName, setPackageName] = useState<string>(data?.packageName)

  const onGroupNameChange = (val: string) => {
    setGroupname(val)
  }
  const isBtnEnabled = !!groupName && !!packageName && (groupName !== data?.group || packageName !== data?.packageName)
  return (
    <Box bg={'TRANSPARENT'} w={'50%'} alignSelf={'center'}>
      <Box {...styles.container} bg={'#f8f9fc' as ColorOptions}>
        <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} title={'Edit Package Data'} />
        <ButtonNew
          title={'Close'}
          onPress={close}
          height={30}
          color={'ERROR'}
          borderRadius={4}
          underlayColor={'TRANSPARENT'}
          hoverColor={'ERROR'}
        />
      </Box>
      <Box {...styles.listContainer}>
        <TextInputNew
          value={groupName ?? data?.group}
          label={'Group Name'}
          onChangeText={onGroupNameChange}
          {...styles.textinput}
        />
        <Spacer direction={'vertical'} size={16} />
        <TextInputNew
          value={packageName ?? data?.packageName}
          label={'Package Name'}
          onChangeText={setPackageName}
          {...styles.textinput}
        />
        <Spacer direction={'vertical'} size={16} />
        <Box align={'flex-end'}>
          <ButtonNew
            title={'Update'}
            underlayColor={'TRANSPARENT'}
            onPress={() => update({ id: data?.id, group: groupName, packageName: packageName })}
            height={36}
            color={'GREEN'}
            borderRadius={4}
            icon={'UPLOAD'}
            width={96}
            disabled={!isBtnEnabled}
          />
        </Box>
      </Box>
    </Box>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  listContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  } as BoxProps,
  textinput: {
    type: 'body14',
    borderColor: '#d1d3e2' as ColorOptions,
    labelPaddingBottom: 8,
    borderRadius: 4,
    labelFontFamily: 'jiotype-bold',
    fontFamily: 'jiotype-medium',
    labelColor: '#6e707e' as ColorOptions,
    labelFontSize: 12,
    fontSize: 14,
    selectionColor: 'BLUE',
    paddingHorizontal: 8,
    color: '#6e707e' as ColorOptions,
    paddingVertical: 8,
    focusBorderColor: '#d1d3e2' as ColorOptions,
    borderWidth: 2,
    onFocusBorderWidth: 2,
  } as TextInputNewProps,
}
